exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-holder{display:flex;justify-content:center}.resource__video{padding-top:0}", ""]);

// exports
